import { render, staticRenderFns } from "./RegularPayment.vue?vue&type=template&id=ee12f804"
import script from "./RegularPayment.vue?vue&type=script&lang=js"
export * from "./RegularPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports